const BASE_URL = "/api/cistcor-logo";

export const PLATFORM_LOGOS = {
  principal: {
    claro: `${BASE_URL}/cistcor-principal-claro.webp`,
    oscuro: `${BASE_URL}/cistcor-principal-oscuro.webp`,
  },
  temporal: {
    claro: `${BASE_URL}/cistcor-temporal-claro.webp`,
    oscuro: `${BASE_URL}/cistcor-temporal-oscuro.webp`,
  },
  favicon: `${BASE_URL}/favicon.ico`,
};

export const FALLBACK_LOGOS = {
  claro: "/logos/logoblanco.png",
  oscuro: "/logos/logonegro.png",
};
